import { environment } from 'environments/environment'

export class MappableModel {
  public metadata: any = { }
  public errors: any

  public constructor(data: any) {
    this.update(data)
  }

  public update(data: any) {
    const model = this as any
    Object.keys(data || {}).forEach(key => {
      try {
        model[key] = data[key]
      } catch (error) {
        if (!environment.production) {
          const modelName = model?.constructor?.name || 'MappableModel'
          console.warn(`[${modelName}] Skipped mapping key "${key}"`, error)
        }
      }
    })
    this.deserialize()
  }

  public deserialize(): void { }
}
